var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success gray bold"},[_vm._v(" 支付失败! "),_c('div',{staticClass:"icon-success iconfont"},[_vm._v("")]),_c('div',{staticClass:"btn-back",on:{"click":function($event){return _vm.$router.push({
      path: '/Personal/Setting',
    })}}},[_vm._v("返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }